// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import LeadFinalApi from "../../api/leadFinalApi.js";
// import StateApi from "../../api/StateApi.js";
// import { showError, showSuccess } from "../../utils/toastUtils.js";

// function RegistrationForm() {
//   const [StateList, setStateList] = useState([]);
//   const [DistrictList, setDistrictList] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [touched, setTouched] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [files, setFiles] = useState([]);
//   const [isFormValid, setIsFormValid] = useState(false);
//   const { id, sourcename } = useParams();
//   const navigate = useNavigate();
//   const isEditMode = Boolean(id);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     country: "India",
//     state: "",
//     district: "",
//     pincode: "",
//     fullAddress: "",
//     companyType: "",
//     company_name: "",
//     company_email: "",
//     alternate_number: "",
//     company_website: "",
//     gst: "",
//     designation: "",
//     remarks: "",
//     whatsapp_number: "",
//   });

//   const patterns = {
//     name: /^[a-zA-Z\s]{3,50}$/,
//     email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
//     phone: /^[6-9]\d{9}$/,
//     pincode: /^[1-9][0-9]{5}$/,
//     gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//     url: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
//   };

//   const handleKeyPress = (e) => {
//     if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
//   };

//   const handleNumberInput = (e, limit) => {
//     if (e.target.value.length > limit)
//       e.target.value = e.target.value.slice(0, limit);
//   };

//   const validateField = (name, value) => {
//     if (!value && ["name", "email", "phone"].includes(name)) {
//       return `${name} is required`;
//     }
//     switch (name) {
//       case "name":
//         return value && !patterns.name.test(value)
//           ? "Invalid name (alphabets only)"
//           : "";
//       case "email":
//         return value && !patterns.email.test(value)
//           ? "Invalid email address"
//           : "";
//       case "phone":
//       case "alternate_number":
//       case "whatsapp_number":
//         if (value && !patterns.phone.test(value))
//           return "Invalid 10-digit number";
//         return "";
//       case "pincode":
//         return value && !patterns.pincode.test(value)
//           ? "Invalid 6-digit pincode"
//           : "";
//       case "gst":
//         if (value && !patterns.gst.test(value)) return "Invalid GST format";
//         return "";
//       case "company_website":
//         if (value && value.trim() !== "" && !patterns.url.test(value))
//           return "Invalid URL format";
//         return "";
//       default:
//         return "";
//     }
//   };

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       const newErrors = {};
//       Object.keys(formData).forEach((key) => {
//         const error = validateField(key, formData[key]);
//         if (error) newErrors[key] = error;
//       });
//       setErrors(newErrors);
//       const requiredFields = ["name", "email", "phone"];
//       const allRequiredFilled = requiredFields.every(
//         (field) => formData[field]?.trim() !== "",
//       );
//       setIsFormValid(allRequiredFilled && Object.keys(newErrors).length === 0);
//     }, 500);
//     return () => clearTimeout(handler);
//   }, [formData]);

//   useEffect(() => {
//     const fetchStates = async () => {
//       const res = await StateApi.getStates();
//       if (res.code === 200) setStateList(res.data);
//     };
//     fetchStates();
//   }, []);

//   useEffect(() => {
//     if (id) {
//       fetchLead();
//     }
//   }, [id]);

//   const fetchLead = async () => {
//     try {
//       const res = await LeadFinalApi.details(id);

//       if (res.code === 200) {
//         const lead = res.data;

//         setFormData({
//           name: lead.name || "",
//           email: lead.email || "",
//           phone: lead.phone || "",
//           country: lead.country || "India",
//           state: lead.state?._id || lead.state || "",
//           district: lead.district?._id || lead.district || "",
//           pincode: lead.pincode || "",
//           fullAddress: lead.fullAddress || "",
//           companyType: lead.companyType || "",
//           company_name: lead.company_name || "",
//           company_email: lead.company_email || "",
//           alternate_number: lead.alternate_number || "",
//           company_website: lead.company_website || "",
//           gst: lead.gst || "",
//           designation: lead.designation || "",
//           remarks: lead.remarks || "",
//           whatsapp_number: lead.whatsapp_number || "",
//         });

//         if (lead.state) {
//           fetchDistrictData(lead.state?._id || lead.state);
//         }
//       }
//     } catch (err) {
//       showError(err.message);
//     }
//   };

//   const fetchDistrictData = async (stateId) => {
//     if (!stateId) return;
//     try {
//       const res = await StateApi.getDistrictsByState(stateId);
//       if (res.code === 200) setDistrictList(res.data);
//     } catch {
//       showError("Failed to fetch Districts");
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setTouched((prev) => ({ ...prev, [name]: true }));
//     if (name === "state") {
//       setFormData((prev) => ({ ...prev, district: "" }));
//       fetchDistrictData(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isFormValid) return;
//     try {
//       setLoading(true);
//       const finalData = new FormData();
//       Object.keys(formData).forEach((key) =>
//         finalData.append(key, formData[key]),
//       );
//       finalData.append("sourceUrl", sourcename || "");
//       if (files.length > 0)
//         Array.from(files).forEach((file) =>
//           finalData.append("attachments", file),
//         );
//       let res;

//       if (isEditMode) {
//         const payload = {
//           id,
//           ...formData,
//         };

//         res = await LeadFinalApi.update(payload);
//       } else {
//         res = await LeadFinalApi.add(finalData);
//       }
//       if (res.code === 200 || res.code === 201) {
//         showSuccess(
//           isEditMode
//             ? "Lead updated successfully"
//             : "Lead created successfully",
//         );

//         if (isEditMode) {
//           navigate(`/lead-details/${id}`);
//           return;
//         }

//         setFormData({
//           name: "",
//           email: "",
//           phone: "",
//           country: "India",
//           state: "",
//           district: "",
//           pincode: "",
//           fullAddress: "",
//           companyType: "",
//           company_name: "",
//           company_email: "",
//           alternate_number: "",
//           company_website: "",
//           gst: "",
//           designation: "",
//           remarks: "",
//           whatsapp_number: "",
//         });

//         setTouched({});
//         setFiles([]);
//       } else {
//         showError(res.message);
//       }
//     } catch (err) {
//       showError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getValidationClass = (name) => {
//     if (!touched[name]) return "form-control";
//     return errors[name] ? "form-control is-invalid" : "form-control is-valid";
//   };

//   return (
//     <section className="container leadform">
//       <style>{`
//         input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
//         input[type=number] { -moz-appearance: textfield; }
//       `}</style>

//       <div className="m-5">
//         <div className="d-flex justify-content-center">
//           <img
//             className="formlogo mt-4"
//             alt="Logo"
//             src="/assets/img/logo.png"
//             style={{ width: "200px" }}
//           />
//         </div>
//         <h1 className="text-center mt-3">Lead Registration Form</h1>

//         <form className="row" onSubmit={handleSubmit}>
//           <h6 className="mt-4 mb-3 fw-bold text-primary">
//             Contact Information
//           </h6>

//           <div className="col-md-4 mb-3">
//             <label className="form-label">
//               Name <span className="text-danger">*</span>
//             </label>
//             <input
//               name="name"
//               type="text"
//               className={getValidationClass("name")}
//               value={formData.name}
//               onChange={handleChange}
//             />
//             {touched.name && errors.name && (
//               <div className="invalid-feedback">{errors.name}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label className="form-label">
//               Email <span className="text-danger">*</span>
//             </label>
//             <input
//               name="email"
//               type="text"
//               className={getValidationClass("email")}
//               value={formData.email}
//               onChange={handleChange}
//             />
//             {touched.email && errors.email && (
//               <div className="invalid-feedback">{errors.email}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label className="form-label">
//               Phone Number <span className="text-danger">*</span>
//             </label>
//             <input
//               name="phone"
//               type="number"
//               className={getValidationClass("phone")}
//               value={formData.phone}
//               onChange={handleChange}
//               onKeyPress={handleKeyPress}
//               onInput={(e) => handleNumberInput(e, 10)}
//             />
//             {touched.phone && errors.phone && (
//               <div className="invalid-feedback">{errors.phone}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Alternate Number</label>
//             <input
//               name="alternate_number"
//               type="number"
//               className={getValidationClass("alternate_number")}
//               value={formData.alternate_number}
//               onChange={handleChange}
//               onKeyPress={handleKeyPress}
//               onInput={(e) => handleNumberInput(e, 10)}
//             />
//             {touched.alternate_number && errors.alternate_number && (
//               <div className="invalid-feedback">{errors.alternate_number}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">WhatsApp Number</label>
//             <input
//               name="whatsapp_number"
//               type="number"
//               className={getValidationClass("whatsapp_number")}
//               value={formData.whatsapp_number}
//               onChange={handleChange}
//               onKeyPress={handleKeyPress}
//               onInput={(e) => handleNumberInput(e, 10)}
//             />
//             {touched.whatsapp_number && errors.whatsapp_number && (
//               <div className="invalid-feedback">{errors.whatsapp_number}</div>
//             )}
//           </div>

//           <h6 className="mt-4 mb-3 fw-bold text-primary">Address Details</h6>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">
//               State <span className="text-danger">*</span>
//             </label>
//             <select
//               className={getValidationClass("state")}
//               name="state"
//               value={formData.state}
//               onChange={handleChange}
//             >
//               <option value="" disabled>
//                 Select State
//               </option>
//               {StateList.map((state) => (
//                 <option key={state._id} value={state._id}>
//                   {state.name}
//                 </option>
//               ))}
//             </select>
//             {touched.state && errors.state && (
//               <div className="invalid-feedback">{errors.state}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">
//               District <span className="text-danger">*</span>
//             </label>
//             <select
//               className={getValidationClass("district")}
//               name="district"
//               value={formData.district}
//               onChange={handleChange}
//               disabled={!formData.state}
//             >
//               <option value="">Select District</option>
//               {DistrictList.map((district) => (
//                 <option key={district._id} value={district._id}>
//                   {district.name}
//                 </option>
//               ))}
//             </select>
//             {touched.district && errors.district && (
//               <div className="invalid-feedback">{errors.district}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">
//               Pincode <span className="text-danger">*</span>
//             </label>
//             <input
//               name="pincode"
//               type="number"
//               className={getValidationClass("pincode")}
//               value={formData.pincode}
//               onChange={handleChange}
//               onKeyPress={handleKeyPress}
//               onInput={(e) => handleNumberInput(e, 6)}
//             />
//             {touched.pincode && errors.pincode && (
//               <div className="invalid-feedback">{errors.pincode}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Country</label>
//             <input
//               className="form-control"
//               type="text"
//               value={"India"}
//               readOnly
//             />
//           </div>

//           <div className="col-md-12 mb-3">
//             <label className="form-label">Full Address</label>
//             <textarea
//               name="fullAddress"
//               rows={2}
//               className="form-control"
//               value={formData.fullAddress}
//               onChange={handleChange}
//             />
//           </div>

//           <h6 className="mt-4 mb-3 fw-bold text-primary">
//             Company Details (B2B)
//           </h6>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Company Type</label>{" "}
//             <select
//               name="companyType"
//               className={getValidationClass("companyType")}
//               value={formData.companyType}
//               onChange={handleChange}
//             >
//               <option value="">Select</option>
//               <option>Pvt Ltd</option>
//               <option>LLP</option>
//               <option>Partnership</option>
//               <option>Proprietorship</option>
//             </select>
//             {touched.companyType && errors.companyType && (
//               <div className="invalid-feedback">{errors.companyType}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Company Name</label>
//             <input
//               name="company_name"
//               type="text"
//               className="form-control"
//               value={formData.company_name}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Company Email</label>
//             <input
//               name="company_email"
//               type="text"
//               className="form-control"
//               value={formData.company_email}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Company Website</label>
//             <input
//               name="company_website"
//               type="text"
//               className={getValidationClass("company_website")}
//               value={formData.company_website}
//               onChange={handleChange}
//             />
//             {touched.company_website && errors.company_website && (
//               <div className="invalid-feedback">{errors.company_website}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Gst Number</label>
//             <input
//               name="gst"
//               type="text"
//               className={getValidationClass("gst")}
//               value={formData.gst}
//               onChange={handleChange}
//             />
//             {touched.gst && errors.gst && (
//               <div className="invalid-feedback">{errors.gst}</div>
//             )}
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Designation</label>
//             <input
//               name="designation"
//               type="text"
//               className="form-control"
//               value={formData.designation}
//               onChange={handleChange}
//             />
//           </div>

//           <h6 className="mt-4 mb-3 fw-bold text-primary">Remarks & Notes</h6>
//           <div className="col-md-12 mb-3">
//             <label className="form-label">Remarks / Description</label>
//             <textarea
//               name="remarks"
//               rows={3}
//               className="form-control"
//               value={formData.remarks}
//               onChange={handleChange}
//             />
//           </div>

//           <h6 className="mt-4 mb-3 fw-bold text-primary">Attachments</h6>
//           <div className="col-md-12 mb-3">
//             <label className="form-label">Upload Documents</label>
//             <input
//               type="file"
//               multiple
//               className="form-control"
//               accept=".pdf,.jpg,.png,.docx"
//               onChange={(e) => setFiles(e.target.files)}
//             />
//           </div>

//           <div className="d-flex justify-content-end mt-4">
//             <button
//               type="reset"
//               className="btn btn-light me-2"
//               onClick={() => {
//                 setFormData({
//                   name: "",
//                   email: "",
//                   phone: "",
//                   country: "India",
//                   state: "",
//                   district: "",
//                   pincode: "",
//                   fullAddress: "",
//                   companyType: "",
//                   company_name: "",
//                   company_email: "",
//                   alternate_number: "",
//                   company_website: "",
//                   gst: "",
//                   designation: "",
//                   remarks: "",
//                   whatsapp_number: "",
//                 });
//                 setTouched({});
//                 setErrors({});
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className={`btn btn-primary ${!isFormValid || loading ? "disabled" : ""}`}
//               disabled={!isFormValid || loading}
//             >
//               {loading
//                 ? "Processing..."
//                 : isEditMode
//                   ? "Update Lead"
//                   : "Create Lead"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// }

// export default RegistrationForm;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import LeadFinalApi from "../../api/leadFinalApi.js";
import { showError, showSuccess } from "../../utils/toastUtils.js";

function RegistrationForm() {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const isEditMode = Boolean(id);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    remarks: "",
  });

  const patterns = {
    name: /^[a-zA-Z\s]{3,50}$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    phone: /^[6-9]\d{9}$/,
  };

  /* ================= VALIDATION ================= */

  const validateField = (name, value) => {
    if (!value?.trim() && ["name", "email", "phone"].includes(name)) {
      return `${name === "phone" ? "Phone number" : name} is required`;
    }

    switch (name) {
      case "name":
        return value && !patterns.name.test(value)
          ? "Invalid name. Alphabets only."
          : "";

      case "email":
        return value && !patterns.email.test(value)
          ? "Invalid email address"
          : "";

      case "phone":
        return value && !patterns.phone.test(value)
          ? "Invalid 10-digit mobile number"
          : "";

      default:
        return "";
    }
  };

  useEffect(() => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);

      if (error) {
        newErrors[key] = error;
      }
    });

    setErrors(newErrors);
  }, [formData]);

  /* ================= FETCH LEAD FOR EDIT ================= */

  useEffect(() => {
    if (id) {
      fetchLead();
    }
  }, [id]);

  const fetchLead = async () => {
    try {
      const res = await LeadFinalApi.details(id);

      if (res.code === 200) {
        const lead = res.data;

        setFormData({
          name: lead.name || "",
          email: lead.email || "",
          phone: lead.phone || "",
          remarks: lead.remarks || "",
        });
      }
    } catch (err) {
      showError(err.message);
    }
  };

  /* ================= INPUT CHANGE ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  /* ================= NUMBER INPUT ================= */

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    setTouched((prev) => ({
      ...prev,
      phone: true,
    }));
  };

  /* ================= FORM VALIDATION ================= */

  const isFormValid =
    formData.name.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.phone.trim() !== "" &&
    Object.keys(errors).length === 0;

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);

      if (error) {
        newErrors[key] = error;
      }
    });

    setErrors(newErrors);

    setTouched({
      name: true,
      email: true,
      phone: true,
      remarks: true,
    });

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setLoading(true);

      if (isEditMode) {
        const payload = {
          id,
          name: formData.name.trim(),
          email: formData.email.trim().toLowerCase(),
          phone: formData.phone.trim(),
          remarks: formData.remarks.trim(),
        };

        const res = await LeadFinalApi.update(payload);

        if (res.code === 200 || res.code === 201) {
          showSuccess("Lead updated successfully");

          navigate(`/lead-details/${id}`);
          return;
        }

        showError(res.message);
        return;
      }

      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: formData.phone.trim(),
        remarks: formData.remarks.trim(),
      };

      const res = await LeadFinalApi.add(payload);

      if (res.code === 200 || res.code === 201) {
        showSuccess("Lead created successfully");

        setFormData({
          name: "",
          email: "",
          phone: "",
          remarks: "",
        });

        setTouched({});
        setErrors({});
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ================= VALIDATION CLASS ================= */

  const getValidationClass = (name) => {
    if (!touched[name]) {
      return "form-control";
    }

    return errors[name]
      ? "form-control is-invalid"
      : "form-control is-valid";
  };

  return (
    <section className="container leadform">
      <style>{`
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type=number] {
          -moz-appearance: textfield;
        }
      `}</style>

      <div className="m-5">

        {/* ================= LOGO ================= */}

        <div className="d-flex justify-content-center">
          <img
            className="formlogo mt-4"
            alt="Logo"
            src="/assets/img/logo.png"
            style={{ width: "200px" }}
          />
        </div>

        <h1 className="text-center mt-3">
          {isEditMode ? "Update Lead" : "Lead Registration Form"}
        </h1>

        <form className="row" onSubmit={handleSubmit}>

          {/* ================= NAME ================= */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Name <span className="text-danger">*</span>
            </label>

            <input
              name="name"
              type="text"
              className={getValidationClass("name")}
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter name"
            />

            {touched.name && errors.name && (
              <div className="invalid-feedback">
                {errors.name}
              </div>
            )}
          </div>

          {/* ================= EMAIL ================= */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Email Address <span className="text-danger">*</span>
            </label>

            <input
              name="email"
              type="email"
              className={getValidationClass("email")}
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
            />

            {touched.email && errors.email && (
              <div className="invalid-feedback">
                {errors.email}
              </div>
            )}
          </div>

          {/* ================= PHONE ================= */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Phone Number <span className="text-danger">*</span>
            </label>

            <input
              name="phone"
              type="text"
              inputMode="numeric"
              maxLength={10}
              className={getValidationClass("phone")}
              value={formData.phone}
              onChange={handlePhoneChange}
              placeholder="Enter 10-digit phone number"
            />

            {touched.phone && errors.phone && (
              <div className="invalid-feedback">
                {errors.phone}
              </div>
            )}
          </div>

          {/* ================= REMARK ================= */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Remark
            </label>

            <textarea
              name="remarks"
              rows={3}
              className="form-control"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Enter remark"
            />
          </div>

          {/* ================= BUTTONS ================= */}

          <div className="d-flex justify-content-end mt-4">

            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => {
                setFormData({
                  name: "",
                  email: "",
                  phone: "",
                  remarks: "",
                });

                setTouched({});
                setErrors({});
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isFormValid || loading}
            >
              {loading
                ? "Processing..."
                : isEditMode
                  ? "Update Lead"
                  : "Create Lead"}
            </button>

          </div>
        </form>
      </div>
    </section>
  );
}

export default RegistrationForm;
